import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const DisableBackButton = ({ redirectUrl, reload }) => {
  const history = useHistory()
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    const handlePopState = (event) => {
      window.history.pushState(null, document.title, redirectUrl || window.location.href)
      if(reload) {
        window.location.reload()
      }
    }
    window.addEventListener('popstate', handlePopState)
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  return null
}

export default DisableBackButton
